import {CachedRounded, DeleteRounded, HighlightOffRounded, Person, SearchRounded} from "@mui/icons-material";
import {Chip, IconButton, Stack, Typography, useTheme} from "@mui/material";
import {SyntheticEvent, useMemo} from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {useRecoilValue} from "recoil";
import {formatCurrency, getLocaleByLang} from "../../../../utils";
import {LOCALES} from "../../../../config";
import {CREDIT_TYPE_VALUES} from "../../../ra-filling/config";
import {bookingDataValueState} from "../../../state";

interface IHeaderDriverData {
    title: string,
    cbId: string,
    amountAdditionalDriverAncillary: number,
    currency: string,
    verifiedDocuments: boolean,
    handleClickSearch:(e: SyntheticEvent) => void,
    handleClickClear: (e: SyntheticEvent) => void,
    handleClickReload: (e: SyntheticEvent) => void,
    handleDeleteAdditionalDriver?: (e: SyntheticEvent) => void,
    disabled: boolean | undefined
}

const HeaderDriverData = ({title, cbId, handleClickSearch, handleClickClear, handleClickReload, disabled, handleDeleteAdditionalDriver, amountAdditionalDriverAncillary, currency, verifiedDocuments}: IHeaderDriverData) => {
    const {t, i18n} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const bookingDataValue: any = useRecoilValue(bookingDataValueState);

    const locale = useMemo((): 'it-IT' | 'en-IN' | 'fr-FR' => {
        return getLocaleByLang(i18n.language);
    }, [i18n.language]);

	return (
		<>
            <Stack direction="row" alignItems="center">
                <Stack direction="row" alignItems="center" columnGap={2}>
                    <Typography variant="h6">
                        {title}
                    </Typography>
                    {cbId &&(
                        <Link to={`/customerbase/view/${cbId}`} onClick={e => e.stopPropagation()} target="_blank">
                            <Person color="secondary"/>
                        </Link>
                    )}
                    {(!!cbId && (verifiedDocuments !== null) && (verifiedDocuments !== undefined)) && 
                        <Chip
                            label={t(`customerData.accordion.documentStatus.${verifiedDocuments? 'valid' : 'toValidate'}`)}
                            sx={{color: "white", backgroundColor: verifiedDocuments ? theme.palette.success.main : theme.palette.error.main}}
                    />
                    }
                </Stack>

            </Stack>
            <Stack direction="row" alignItems="center" ml="auto" mr={2}>
                {
                    !!amountAdditionalDriverAncillary && bookingDataValue.financialInfo.creditType !== CREDIT_TYPE_VALUES.FULL_CREDIT &&
                    <Typography  variant={"bodyLarge"} component={'span'} sx={{mr: theme.spacing(2)}}>
                        <strong>
                            {formatCurrency(locale as LOCALES, amountAdditionalDriverAncillary, currency)}
                        </strong>
                    </Typography>
                }

                {
                    !!handleDeleteAdditionalDriver && // bookingDataValue.financialInfo.creditType !== CREDIT_TYPE_VALUES.FULL_CREDIT &&
                    <IconButton
                        title={t('customerData.button.removeDriver')}
                        onClick={(e) => handleDeleteAdditionalDriver(e)}
                        disabled={disabled}
                    >
                        <HighlightOffRounded />
                    </IconButton>
                }

                <IconButton title={t('customerData.button.searchDriver')} onClick={handleClickSearch} disabled={disabled}>
                    <SearchRounded />
                </IconButton>
                <IconButton title={t('customerData.button.clearDriver')} onClick={handleClickClear} disabled={disabled}>
                    <DeleteRounded />
                </IconButton>
                <IconButton title={t('customerData.button.reloadDriver')} onClick={handleClickReload} disabled={disabled || verifiedDocuments}>
                    <CachedRounded />
                </IconButton>
            </Stack>
		</>
	);
}

export default HeaderDriverData
